<template>
    <div id="winners" class="d-flex flex-column w-100 my-5">
        <div class="mx-auto mb-2">
            <a href="https://racorestebarbatul.ro/lista-castigatorilor/" class="links" target="_blank">
                <img src="../assets/img/Component11–1(HoverState).png" alt="" class="img-fluid img-top">
                <img src="../assets/img/Component11–1.png" alt="" class="img-fluid img-bot">
            </a>
        </div>
        <div class="mx-auto mb-2 px-3 px-md-2">
            <a href="https://racorestebarbatul.ro/lista-centrelor-de-premiere/" class="links" target="_blank">
                <img src="../assets/img/Component13–1(HoverState).png" alt="" class="img-top img-fluid">
                <img src="../assets/img/Component13–1.png" alt="" class="img-fluid img-bot">
            </a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Winners",
    }
</script>

<style scoped>
    .links {
        position: relative;
        display: inline-block;
        max-width: 600px;
    }

    .links .img-top {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
    }

    .links:hover .img-top {
        display: inline;
    }
    .links:hover .img-bot {
        opacity: 0;
    }
</style>
